import { render, staticRenderFns } from "./mensajesResidente.vue?vue&type=template&id=4f0a0e81&scoped=true"
import script from "./mensajesResidente.vue?vue&type=script&lang=js"
export * from "./mensajesResidente.vue?vue&type=script&lang=js"
import style0 from "./mensajesResidente.vue?vue&type=style&index=0&id=4f0a0e81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a0e81",
  null
  
)

export default component.exports